/**
 * Ourora Text Styles - TypeScript utility
 * Matching Flutter implementation
 */

export const textStyles = {
  // Display Styles
  displayRegular: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '36px',
    fontWeight: 400,
    lineHeight: 1.2,
  },
  displayBold: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '36px',
    fontWeight: 700,
    lineHeight: 1.2,
  },

  // Title 1 Styles
  title1Regular: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '28px',
    fontWeight: 400,
    lineHeight: 1.2,
  },
  title1Bold: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: 1.2,
  },

  // Title 2 Styles
  title2Regular: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: 1.2,
  },
  title2Bold: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: 1.2,
  },

  // Headline Styles
  headlineRegular: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: 1.2,
  },
  headlineBold: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: 1.2,
  },

  // Body Styles
  bodyRegular: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  bodyBold: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: 1.5,
  },
  bodyItalics: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '14px',
    fontWeight: 400,
    fontStyle: 'italic',
    lineHeight: 1.5,
  },

  // SubHeadline Styles
  subHeadlineRegular: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  subHeadlineBold: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 1.5,
  },

  // Callout Styles
  calloutRegular: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  calloutBold: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: 1.5,
  },
  calloutItalics: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '12px',
    fontWeight: 400,
    fontStyle: 'italic',
    lineHeight: 1.5,
  },

  // Footnote Styles
  footnoteRegular: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  footnoteBold: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '10px',
    fontWeight: 700,
    lineHeight: 1.5,
  },
  footnoteItalics: {
    fontFamily: "'Lato', sans-serif",
    fontSize: '10px',
    fontWeight: 400,
    fontStyle: 'italic',
    lineHeight: 1.5,
  },
};

